import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import { FLOW_NAVIGATION_ACTIONS } from '../../../../flows/DynamicFlow/utilities/constants';
import theme from '../../../ui-kit/themes/theme';
import { SummaryContent } from '../Content';
import { Divider } from '../Content/styles';
import SummaryAccordion from '../SummaryAccordion';
import { AdditionalCharges } from './Content/AdditionalCharges';
import PackagesList from './Content/PackagesList';
import SimpleSummaryDue from './SimpleSummaryDue';
import SimpleSummaryFooter from './SimpleSummaryFooter';
import SimpleSummaryHeader from './SimpleSummaryHeader';
import SimpleSummaryInfo from './SimpleSummaryInfo';
import SimpleSummaryParkingFeeWarning from './SimpleSummaryParkingFeeWarning';

export const SimpleSummary = ({
  bookingSummaryParkingFee,
  operaCode,
  onChange,
  title,
  shouldStartCollapsed,
  deletePackage,
  upsertPackage,
  total,
  productTitle,
  promoCode,
  fullWidthDescription,
  description,
  price,
  navigationText,
  packagesList,
  taxes,
  showDueToday,
  dueToday,
  dueBeforeParty,
  sustainabilityFee,
  parkingFee,
  resortFee,
  leftTitle,
  leftContent,
  rightTitle,
  rightContent,
  onPaymentPage,
  includedList,
  remainingBalanceDueDate,
  splitPackagesByTabName,
  allowPackageUpdate,
  triggerDynamicStepNavigation,
  allowPackagesListLink
}) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.md})`
  });
  const history = useHistory();
  const onInfoLinkClick = () => {
    triggerDynamicStepNavigation(FLOW_NAVIGATION_ACTIONS.FLOW_TRIGGER_FIRST_STEP);
    if (isMobile) {
      history.push({
        search: '?openEditMobile=true'
      });
    }
  };

  return (
    <SummaryAccordion
      total={total}
      onChange={onChange}
      shouldStartCollapsed={shouldStartCollapsed}
      title={title}
      isOnPaymentPage={onPaymentPage}>
      {({ expanded, isDesktop }) => {
        return (
          <>
            {expanded ? (
              <SummaryContent>
                <SimpleSummaryHeader
                  leftTitle={leftTitle}
                  leftContent={leftContent}
                  rightTitle={rightTitle}
                  rightContent={rightContent}
                />
                <SimpleSummaryInfo
                  promoCode={promoCode}
                  fullWidthDescription={fullWidthDescription}
                  description={description}
                  productTitle={productTitle}
                  price={price}
                  navigationText={navigationText}
                  onNavigateLinkClick={onInfoLinkClick}
                  includedList={includedList}
                />
                <Divider />
                <PackagesList
                  currentSelectedPackages={packagesList}
                  deletePackage={deletePackage}
                  splitPackagesByTabName={splitPackagesByTabName}
                  allowPackageUpdate={allowPackageUpdate}
                  upsertPackage={upsertPackage}
                  triggerDynamicStepNavigation={triggerDynamicStepNavigation}
                  allowPackagesListLink={allowPackagesListLink}
                />
                {onPaymentPage ? (
                  <AdditionalCharges
                    taxes={taxes}
                    sustainabilityFee={sustainabilityFee}
                    parkingFee={parkingFee}
                    resortFee={resortFee}
                    lodgeOperaCode={operaCode}
                  />
                ) : null}
              </SummaryContent>
            ) : null}
            {expanded || isDesktop ? <SimpleSummaryFooter onPaymentPage={onPaymentPage} total={total} /> : null}
            {expanded && bookingSummaryParkingFee && !showDueToday && onPaymentPage ? (
              <SimpleSummaryParkingFeeWarning bookingSummaryParkingFee={bookingSummaryParkingFee} />
            ) : null}
            {expanded && showDueToday ? (
              <SimpleSummaryDue
                dueToday={dueToday}
                dueBeforeParty={dueBeforeParty}
                remainingBalanceDueDate={remainingBalanceDueDate}
                bookingSummaryParkingFee={bookingSummaryParkingFee}
                onPaymentPage={onPaymentPage}
              />
            ) : null}
          </>
        );
      }}
    </SummaryAccordion>
  );
};

export default SimpleSummary;
